import './comments.scss';
//shared
import { CommentsItems } from '../shared/components/comments-items/coments-items';
import { TITLE_BRANCH_COMMENTS } from './constants/title';
import { Titles } from '../shared/components/titles/titles';
//material
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { sendPageView } from '../shared/services/analytics';

export default function Comments({ branch }: { branch: number }) {
    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Comentarios");
    }, [location]);

    return (
        <div className="section-menu section-comments">
            <Titles props={TITLE_BRANCH_COMMENTS} />
            <CommentsItems branchId={branch}></CommentsItems>
        </div>
    );
}